import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { FiChevronRight, FiClock, FiShield, FiMail, FiPhone } from 'react-icons/fi';

const Privacy = () => {
  const sections = [
    {
      title: "Information Collection",
      icon: <FiShield className="section-icon" />,
      content: "We collect personal information you voluntarily provide, including name, email, and contact details when you use our contact forms or services."
    },
    {
      title: "Data Usage",
      icon: <FiClock className="section-icon" />,
      content: "Your information is used solely to provide and improve our services. We never sell your data to third parties."
    },
    // Add more sections as needed
  ];

  return (
    <div className="privacy-container">
      <Helmet>
        <title>Privacy Policy | DashWeb Studio</title>
        <meta name="description" content="Your privacy is important to us. Learn how we protect your data." />
      </Helmet>

      <div className="privacy-hero">
        <div  className="hero-content">
          <h1>Privacy Policy</h1>
          <p className="last-updated">
            <FiClock className="icon" /> Last updated: {new Date().toLocaleDateString('en-US', { 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </p>
        </div>
        <div className="hero-pattern"></div>
      </div>

      <div className="privacy-content">
        <aside className="privacy-sidebar">
          <h3>Quick Links</h3>
          <ul>
            {sections.map((section, index) => (
              <li key={index}>
                <a href={`#section-${index}`}>
                  {section.icon}
                  <span>{section.title}</span>
                  <FiChevronRight className="chevron" />
                </a>
              </li>
            ))}
            <li>
              <a href="#contact">
                <FiMail className="section-icon" />
                <span>Contact Us</span>
                <FiChevronRight className="chevron" />
              </a>
            </li>
          </ul>
        </aside>

        <main className="privacy-main">
          <section className="intro-section">
            <h2>Our Commitment to Your Privacy</h2>
            <p>
              At DashWeb Studio, we prioritize your privacy and are committed to protecting your personal information. 
              This policy outlines how we collect, use, and safeguard your data.
            </p>
          </section>

          {sections.map((section, index) => (
            <section key={index} id={`section-${index}`} className="policy-section">
              <div className="section-header">
                {section.icon}
                <h3>{section.title}</h3>
              </div>
              <p>{section.content}</p>
            </section>
          ))}

          <section id="contact" className="contact-section">
            <h3>Contact Information</h3>
            <div className="contact-methods">
              <div className="contact-card">
                <FiMail className="contact-icon" />
                <a href="mailto:studiodashweb@gmail.com">studiodashweb@gmail.com</a>
              </div>
              <div className="contact-card">
                <FiPhone className="contact-icon" />
                <a href="tel:+96176536462">+961 76536462</a>
              </div>
            </div>
          </section>
        </main>
      </div>

      <div className="privacy-footer">
        <Link to="/" className="back-home">← Back to Home</Link>
        <p>© {new Date().getFullYear()} DashWeb Studio. All rights reserved.</p>
      </div>
    </div>
  );
};

export default Privacy;